import { render } from "./AppUploadArea.vue?vue&type=template&id=a4c1e2ca&scoped=true"
import script from "./AppUploadArea.vue?vue&type=script&lang=js"
export * from "./AppUploadArea.vue?vue&type=script&lang=js"

import "./AppUploadArea.vue?vue&type=style&index=0&id=a4c1e2ca&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4c1e2ca"]])

export default __exports__